<app-modal title="Check Your Email">
  <div class="padBot10">
    <p>
      Thank you for your request! If an account exists for the email you entered, a password reset link has been sent.
    </p>

    <p class="w700">Helpful Tips:</p>

    <ol>
      <li class="tAlignLeft">Please allow up to 2 minutes for the email to arrive.</li>
      <li class="tAlignLeft">Be sure to check your spam or promotions folder.</li>
      <li class="tAlignLeft">
        If you don’t receive an email, please confirm you entered the exact email associated with your SimpleCitizen
        account.
      </li>
    </ol>

    <p>For help, please reach out to our LiveChat team!</p>
  </div>

  <div class="actionBtnContainer">
    <button class="actionBtn w400" [matDialogClose]="{ confirm: true }">Return to Login</button>
  </div>
</app-modal>
